<div class="fixed top-0 left-0 right-0 bottom-0 bg-(--loading-overlay-color) opacity-95 z-2"></div>
<div class="fixed inset-0 z-3 overflow-y-auto">
    <div class="min-h-dvh flex flex-col justify-center items-center py-8">
    <span class="w-full px-3 lg:max-w-3xl flex flex-col gap-3">
        <span class="flex flex-col mb-5">
            <div class="text-white text-3xl font-semibold mb-1">Invite Participants</div>
        </span>
        <mat-form-field appearance="fill" id="new-project" class="w-full text-white">
            <mat-label></mat-label>
            <textarea matInput [value]="emailsText()" (input)="onEmailsInput($event)"
                aria-label="Participant email addresses"></textarea>
        </mat-form-field>
        <span class="text-(--hint-color)">Please enter a comma separated list of participant emails. Each
            will receive an invitation from Hogan Assessment Systems to complete their assigned
            assessments. <button type="button"
                class="text-(--hint-color) font-semibold underline appearance-none bg-transparent border-0 p-0 cursor-pointer disabled:opacity-60 disabled:cursor-default"
                [disabled]="isSendingSample()" (click)="onSendSampleClick()">
                {{ isSendingSample() ? 'Sending Sample Invitation…' : 'Send Sample Invitation' }}
            </button>
        </span>
        @if(errors().length > 0) {
        <span class="text-red-500 text-sm">
            {{ errors()[0] }}
        </span>
        }
        @if(apiError()) {
        <span class="text-red-500 text-sm">
            {{ apiError() }}
        </span>
        }
        <span class="flex flex-row gap-5">
            <button matButton="filled" class="min-w-[100px]!"
                [disabled]="!emailsText().trim() || errors().length > 0 || isSubmitting()" (click)="onAddClick()">
                Add
            </button>
            <a matButton="filled" class="min-w-[100px]!" routerLink="..">Cancel</a>
        </span>
    </span>
</div>
</div>
